import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAtom, faChartLine, faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';
import { faLightbulb, faChartBar, faComments } from '@fortawesome/free-regular-svg-icons';
import { Psychology, TrendingUp, School } from '@mui/icons-material';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const skillsLabels = [
    "Python",
    "SQL",
    "Snowflake",
    "PyTorch",
    "TensorFlow",
    "AWS",
    "Docker",
    "Kubernetes",
    "Prometheus",
    "Grafana",
    "Terraform",
    "FastAPI",
    "Airflow",
    "GitHub Actions",
    "React",
    "GCP",
    "Azure",
    "dbt",
    "Tableau",
    "Power BI",
    "Sklearn",
    "R",
    "and more ..."
];


const useCasesLabelsFirst = [
    "Text Processing",
    "Audio Analysis",
    "Chat Bots",
    "Anomaly Detection",
    "Recommender Systems",
    "Forecasting"
];

const useCasesLabelsSecond = [
    "Data Warehousing",
    "Dashboards",
    "Data Visualization",
    "ETL Pipelines",
    "Data Quality Testing",
    "Data Governance",
];

const useCasesLabelsThird = [
    "Upskilling",
    "Workshops",
    "Conference Talks",
    "Use Case Ideation",
    "Hackathons",
    "Mentorship",
    "Podcasts",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <Psychology style={{fontSize: '4rem'}}/>
                    <h3>Machine Learning & AI</h3>
                    <p>Automate complex business processes with smart machine learning and AI algorithms.</p>

                    <div className="category">
                        <h4>Use Cases</h4>
                        <div className="flex-chips">
                            {useCasesLabelsFirst.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>

                    <div className="Projects">
                        <h4>Project Examples</h4>
                        <p>
                        <ul>
                            <li>AI Slack bot for querying database tables with natural language</li>
                            <li>Deep-learning based music tagging and audio analysis</li>
                            <li>Anomaly detection for quality assurance in daily business KPIs</li>
                        </ul>
                        </p>
                    </div>

                </div>

                <div className="skill">
                    <TrendingUp style={{fontSize: '4rem'}}/>
                    <h3>Data & Analytics</h3>
                    <p>Make data-driven decisions at scale through efficient data pipelines and reliable analytics.</p>

                    <div className="category">
                        <h4>Use Cases</h4>
                        <div className="flex-chips">
                            {useCasesLabelsSecond.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                    
                    <div className="Projects">
                        <h4>Project Examples</h4>
                        <p>
                        <ul>
                            <li>Automated data quality monitoring for large-scale event data streams</li>
                            <li>Near-real time ETL pipeline and dashboard for A/B testing of media teaser images</li>
                            <li>User demography dashboard based on market research and logged-in user data</li>
                        </ul>
                        </p>
                    </div>
                </div>

                <div className="skill">
                    <School style={{fontSize: '4rem'}}/>
                    <h3>Trainings & Public Speaking</h3>
                    <p>Stay relevant in the market by catching up to new trends and technologies in data & AI.</p>

                    <div className="category">
                        <h4>Use Cases</h4>
                        <div className="flex-chips">
                            {useCasesLabelsThird.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>

                    <div className="Projects">
                            <h4>Project Examples</h4>
                            <p>
                            <ul>
                                <li>LLM Finetuning workshop for a leading Swiss financial services company</li>
                                <li>Large-scale data & AI upskilling initiative for a German insurance</li>
                                <li>GenAI Hackathon for a large German car manufacturer</li>
                            </ul>
                            </p>
                    </div>
                </div>
            </div>
            <div className="category">
                <h4>Tech Stack</h4>
                <div className="flex-chips">
                    {skillsLabels.map((label, index) => (
                        <Chip key={index} className='chip' label={label} />
                    ))}
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;